import { Schema as S } from "effect";

export const ListTenantsRequestSchema = S.Struct({});

export type ListTenantsRequest = S.Schema.Type<typeof ListTenantsRequestSchema>;
